import React, { useState, useEffect } from "react";
import { Form, Input, Button, Divider, message, Upload } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import * as api from "../../api";
import Layout from "../../components/admin/layout";

const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 8 },
};
const tailLayout = {
  wrapperCol: { offset: 6, span: 8 },
};

let initImage = {
  how_to_image_step_1: undefined,
  how_to_image_step_2: undefined,
  how_to_image_step_3: undefined,
};

const HowTo = () => {
  const [form] = Form.useForm();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [content, setContent] = useState([]);
  const [image, setImage] = useState(initImage);

  useEffect(() => {
    init();
  }, []);

  async function init() {
    try {
      const {
        data: { data },
      } = await api.getContent();
      setContent(data.content);
      setImage({
        how_to_image_step_1:
          data.content["how_to_image_step_1"],
          how_to_image_step_2:
          data.content["how_to_image_step_2"],
          how_to_image_step_3:
          data.content["how_to_image_step_3"],
      });
      form.setFieldsValue(data.content);
    } catch (error) {
      console.log("Error while call init()", error);
    }
  }

  function beforeUpload(file) {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      message.error("You can only upload JPG/PNG file!");
    }
    return isJpgOrPng;
  }

  function handleChange(info, key) {
    if (info.file.status === "done") {
      setImage((prev) => ({ ...prev, [key]: info.file.response.data.url }));
    }
  }

  const onFinish = (values) => {
    update({
      ...values,
      ...image

    })
  };


  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  async function update(data) {
    try {
      setIsSubmitting(true)
      const res = await api.updateContent(data)
      message.success('บันทึกเรียบร้อยแล้ว');
    } catch (error) {
      message.success('เกิดข้อผิดพลา ดกรุณาลองใหม่อีกครั้ง');
      console.log("Error while call error()", error);
    }
    setIsSubmitting(false)
  }

  const uploadButton = (
    <div>
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );

  return (
    <Layout>
      <Form
        {...layout}
        form={form}
        name="basic"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Form.Item label="หัวข้อ (ไทย)" name="how_to_title_step_1_th">
          <Input.TextArea rows={4} />
        </Form.Item>
        <Form.Item label="หัวข้อ (อังกฤษ)" name="how_to_title_step_1_en">
          <Input.TextArea rows={4} />
        </Form.Item>
        <Form.Item label="ข้อความ (ไทย)" name="how_to_title_description_1_th">
          <Input.TextArea rows={4} />
        </Form.Item>
        <Form.Item
          label="ข้อความ (อังกฤษ)"
          name="how_to_title_description_1_en"
        >
          <Input.TextArea rows={4} />
        </Form.Item>
        <Form.Item label="รูป" name="how_to_image_step_1">
          <Upload
            name="file"
            listType="picture-card"
            className="avatar-uploader"
            showUploadList={false}
            action={api.upload}
            beforeUpload={beforeUpload}
            onChange={(info) => handleChange(info, "how_to_image_step_1")}
          >
            {image.how_to_image_step_1 ? (
              <img
                src={image.how_to_image_step_1}
                alt="avatar"
                style={{ width: "100%" }}
              />
            ) : (
              uploadButton
            )}
          </Upload>
        </Form.Item>
        <Divider />
        <Form.Item label="หัวข้อ (ไทย)" name="how_to_title_step_2_th">
          <Input.TextArea rows={4} />
        </Form.Item>
        <Form.Item label="หัวข้อ (อังกฤษ)" name="how_to_title_step_2_en">
          <Input.TextArea rows={4} />
        </Form.Item>
        <Form.Item label="ข้อความ (ไทย)" name="how_to_title_description_2_th">
          <Input.TextArea rows={4} />
        </Form.Item>
        <Form.Item
          label="ข้อความ (อังกฤษ)"
          name="how_to_title_description_2_en"
        >
          <Input.TextArea rows={4} />
        </Form.Item>
        <Form.Item label="รูป" name="how_to_image_step_2">
          <Upload
            name="file"
            listType="picture-card"
            className="avatar-uploader"
            showUploadList={false}
            action={api.upload}
            beforeUpload={beforeUpload}
            onChange={(info) => handleChange(info, "how_to_image_step_2")}
          >
            {image.how_to_image_step_2 ? (
              <img
                src={image.how_to_image_step_2}
                alt="avatar"
                style={{ width: "100%" }}
              />
            ) : (
              uploadButton
            )}
          </Upload>
        </Form.Item>
        <Divider />
        <Form.Item label="หัวข้อ (ไทย)" name="how_to_title_step_3_th">
          <Input.TextArea rows={4} />
        </Form.Item>
        <Form.Item label="หัวข้อ (อังกฤษ)" name="how_to_title_step_3_en">
          <Input.TextArea rows={4} />
        </Form.Item>
        <Form.Item label="ข้อความ (ไทย)" name="how_to_title_description_3_th">
          <Input.TextArea rows={4} />
        </Form.Item>
        <Form.Item
          label="ข้อความ (อังกฤษ)"
          name="how_to_title_description_3_en"
        >
          <Input.TextArea rows={4} />
        </Form.Item>
        <Form.Item label="รูป" name="how_to_image_step_3">
          <Upload
            name="file"
            listType="picture-card"
            className="avatar-uploader"
            showUploadList={false}
            action={api.upload}
            beforeUpload={beforeUpload}
            onChange={(info) => handleChange(info, "how_to_image_step_3")}
          >
            {image.how_to_image_step_3 ? (
              <img
                src={image.how_to_image_step_3}
                alt="avatar"
                style={{ width: "100%" }}
              />
            ) : (
              uploadButton
            )}
          </Upload>
        </Form.Item>
      </Form>
    </Layout>
  );
};

export default HowTo;
